module.exports = __webpack_public_path__ + "img/ico_warning.5b39554c.svg";